import React from 'react';
import Section from '@components/Section';
import { SearchState } from '@app/types';
import styles from './RecentSearches.module.scss';
import { RedoIcon, XIcon } from '@components/Icons';
import { useDispatch } from 'react-redux';
import { clearSearchHistory, removeSearchTerm, setSearchTerm } from '@actions/search';

function RecentSearchTerm({ term }: { term: string }) {
  const dispatch = useDispatch();

  return (
    <div className={styles.recentSearchTerm}>
      <button className={styles.selectTermBtn} onClick={() => dispatch(setSearchTerm(term, true))}>
        <span>{term}</span>
      </button>
      <button className={styles.removeTermBtn} onClick={() => dispatch(removeSearchTerm(term))}>
        <XIcon width="10" />
      </button>
    </div>
  );
}

export default function RecentSearches({ search }: { search: SearchState }) {
  const dispatch = useDispatch();

  if (search.recent.length === 0) {
    return null;
  }

  return (
    <Section>
      <Section.Title underline className={styles.title}>
        <RedoIcon className={styles.redoIcon} />
        Recent Searches
      </Section.Title>
      {search.recent.map(({ term }, idx) => (
        <RecentSearchTerm key={idx} term={term} />
      ))}
      <button className={styles.clearBtn} onClick={() => dispatch(clearSearchHistory())}>
        Clear all
        <XIcon width={10} height={10} />
      </button>
    </Section>
  );
}
